import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export interface Variables {
  brandKitId: number
  id: number
}

export const deleteBrandKitSource = async ({ workspaceId, brandKitId, id }: Variables & { workspaceId: number }) => {
  const res = await sendToApi(`/w/${workspaceId}/brand_kits/${brandKitId}/sources/${id}`, {
    method: 'DELETE',
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
}

export interface Options extends Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'> {}

export const useDeleteBrandKitSource = (options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation<void, Error, Variables>(async (vars) => {
    const { id, brandKitId } = vars

    await deleteBrandKitSource({
      workspaceId,
      brandKitId,
      id,
    })

    queryClient.invalidateQueries(['workspaces', workspaceId, 'brandKits'])
  }, options)
}
